import { useTranslation } from 'react-i18next';
import { HouseholdCompositionStep } from '../../../api/screening/findOverview';
import ScreeningOverviewStepTable from './ScreeningOverviewStepTable';

interface ScreeningOverviewHouseholdCompositionStepTableProps {
    data: HouseholdCompositionStep['data'];
}

const ScreeningOverviewHouseholdCompositionStepTable = ({
    data
}: ScreeningOverviewHouseholdCompositionStepTableProps) => {
    const { t } = useTranslation();

    const matchPetSpeciesToTranslation = (species: string) => {
        return t(`screening.overview.step.householdComposition.pets.${species.toLowerCase()}`, species);
    }

    const adults = [
        {
            title: t('screening.overview.step.householdComposition.yourName'),
            value: data.mainHomeseeker.name
        },
        {
            title: t('screening.overview.step.householdComposition.yourEmail'),
            value: data.mainHomeseeker.email
        }
    ];

    if (data.coTenants) {
        data.coTenants.forEach((coTenant, index) => {
            adults.push({
                title: t('screening.overview.step.householdComposition.coTenantName', { index: index + 2 }),
                value: coTenant.name
            });
            adults.push({
                title: t('screening.overview.step.householdComposition.coTenantEmail', { index: index + 2 }),
                value: coTenant.email
            });
        });
    }

    const householdCompositionStepData = [
        {
            subSections: [
                {
                    title: t('screening.overview.step.householdComposition.amountOfAdults'),
                    value: data.householdComposition.amountOfAdults,
                    data: adults
                },
                {
                    title: t('screening.overview.step.householdComposition.amountOfChildren'),
                    value: data.householdComposition.amountOfChildren
                },
                {
                    title: t('screening.overview.step.householdComposition.amountOfPets'),
                    value: data.householdComposition.pets.reduce((sum, item) => sum + item.amount, 0),
                    data: data.householdComposition.pets.map((pet) => ({
                        title: matchPetSpeciesToTranslation(pet.species),
                        value: pet.amount
                    }))
                }
            ]
        }
    ];

    return (
        <ScreeningOverviewStepTable
            data={householdCompositionStepData}
        />
    );
}

export default ScreeningOverviewHouseholdCompositionStepTable;
